import CollectionSearchV2 from '../../online_public_catalog_query_construction/views/collection_search_v2';
import { Row, Col, Button, setParamsFilter, Typography, Form, Input, Select, message, Modal } from '../../ui/ot'
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCRUDController } from '../../ui/classify_structure/CRUDController';
import { useHold } from "../controllers/HoldController";
import { useLibrary } from "../controllers/LibraryController";
import { useBorrower } from "../controllers/BorrowerController";
import { useEffect } from 'react';
import dayjs from 'dayjs'
import { StarIcon, } from "lucide-react"
import ReaderReview from './reader_review';
const LibraryCollectionSearch = ({
    keyPrefix = "library.online_public_catalog_query_construction.collection_search",
    propsForm,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef()
    const [form_] = Form.useForm();
    const form = propsForm ?? form_;
    const [borrowernumber, set_borrowernumber] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const customFormItems = (fieldName) => {
        return (<></>)
    }

    const onFinish = (values) => {
        postHoldData([
            {
                ...values,
                // expiration_date: !!values?.expiration_date ? dayjs(values?.expiration_date).format("YYYY-MM-DD") : dayjs().add(1, 'month').format("YYYY-MM-DD"),
            }
        ])
    }

    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        // if (fieldName) {
        //     if (propsForm) {
        //         formValues = propsForm.getFieldValue(fieldName)
        //     }
        //     else {
        //         formValues = form.getFieldValue(fieldName)
        //     }
        // } else {
        //     if (propsForm) {
        //         formValues = propsForm.getFieldsValue()
        //     }
        //     else {
        //         formValues = form.getFieldsValue()
        //     }
        // }
        // propsOnValuesChange({
        //     ...formValues,
        //     // ...e
        // })
    }

    const onHoldFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("預約成功")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                if(values.includes('itemAlreadyOnHold')){
                    message.error("已經在預約當中")
                }
                else{
                    message.error("預約失敗")
                }
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
            }
        }
        setIsModalOpen(false)
    }
    const {
        LibraryData,
        getLibraryData
    } = useLibrary({
        onBefore: () => { },
    })
    const BorrowerSelfController = useCRUDController({
        apiRoute: "/library/koha/borrower/self",
    })

    const {
        postHoldData,
    } = useHold({
        onFinish: onHoldFinish
    })
    useEffect(() => {
        BorrowerSelfController.getData({})
            .then((response) => {
                let data = response?.data || []
                let data_first = data?.find((ele) => true)
                set_borrowernumber(data_first?.borrowernumber)
            })
        getLibraryData()
    }, [])

    return (<Row>
        <HoldModal
            propsForm={form}
            LibraryData={LibraryData}
            propsOpen={isModalOpen}
            propsSetOpen={setIsModalOpen}
            onFinish={onFinish}
        ></HoldModal>
        <Col span={24}>
            <CollectionSearchV2
                tabs={[
                    {
                        icon: <StarIcon className="mr-2 h-4 w-4" />,
                        tab: "讀者評論",
                        key: "reviews",
                        tabContent: <ReaderReview ></ReaderReview>
                    },
                ]}
                customFormItems={() => {
                    return (customFormItems())
                }} //上層可加入自定義的form item 
                customColumns={[]} //列表編輯模式的顯示columns
                propsCardRender={() => { }} //card 模式要顯示的其他欄位
                extraActionRender={(item) => {
                    return (<>
                        {!!borrowernumber && <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Button
                                    onClick={() => {
                                        setIsModalOpen(true)
                                        form.resetFields()
                                        form.setFieldsValue({
                                            borrowernumber: borrowernumber,
                                            itemnumber: item?.item_itemnumber
                                        })
                                    }}
                                >
                                    {t('hold')}
                                </Button>
                            </Col>
                        </Row>}
                    </>)
                }}
                star={<StarAvg />}
            />
        </Col>
    </Row>)
}
const StarAvg = ({
    biblionumber
}) => {
    const reviewAverageStarController = useCRUDController({
        apiRoute: "/library/api/frontend/review/average_star",
    })
    useEffect(() => {
        if (
            !!biblionumber
        ) {
            reviewAverageStarController.getData({
                biblionumber: biblionumber
            })
        }
    }, [biblionumber])
    return (
        <div>
            {
                reviewAverageStarController?.ResponseData.map((val) => {
                    return <div className="flex items-center gap-1">
                        <StarIcon className="h-4 w-4 fill-white" />
                        <span className="text-sm font-bold">{(val?.star ?? 0).toFixed(1)}</span>
                    </div>
                })
            }

        </div>
    )
}
const HoldModal = (
    {
        keyPrefix = "library.online_public_catalog_query_construction.collection_search",
        axiosMode = "post",
        propsForm,
        propsOpen = null,
        propsLoading = null,
        propsSetOpen = () => {

        },
        onFinish = () => {

        },
        LibraryData = []
    }
) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const axiosModelanguage = {
        post: "新增",
        patch: "修改"
    }
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }

    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])

    return (
        <>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {t('hold')}
                </Button>
            }

            <Modal
                title={`${t('hold')}`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
                okText={t('ok')}
                cancelText={t('cancel')}
            >
                <Row gutter={[8, 8]}>
                    <Col span={24}>
                    </Col>
                    <Col span={24}>
                        <Form
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                            layout="horizontal"
                            form={form}
                            // onValuesChange={onValuesChange}
                            onFinish={onFinish}
                            autoComplete="off"
                        >
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Form.Item
                                        label={'館藏'}
                                        name={"itemnumber"}
                                        rules={[{ required: true, message: "請輸入" }]}
                                        hidden
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('borrowernumber')}
                                        name={"borrowernumber"}
                                        rules={[{ required: true, message: "請輸入" }]}
                                        hidden
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('pickupLibrary')}
                                        name={"pickupLibrary"}
                                        rules={[{ required: true, message: "請輸入" }]}
                                    >
                                        <Select
                                            style={{
                                                maxHeight: "80vh",
                                                minHeight: "20vh",
                                                overflowX: "scroll",
                                                overflowY: "scroll",
                                            }}
                                            options={LibraryData.map(item => (
                                                {
                                                    label: item?.branchname,
                                                    value: item?.branchcode,
                                                }
                                            ))}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Modal>
        </>

    )
}
export default LibraryCollectionSearch